import { UtilsTypes } from '@tencent/wphk-act-base-types';
import { i18n } from './i18n';
import { divide, minus } from 'number-precision';
/**
 * 字符串中是否含有中文
 */
function isChinese(str: string) {
  const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
  if (reg.test(str)) {
    return true;
  }
  return false;
}

/**
 * 统计非中文的字符串中的字符长度
 */
export function nonChineseCharactersLength(str: string) {
  let len = 0;
  if (!isChinese(str)) {
    len = str.length;
  }
  return len;
}
/**
 * 获得合法的currencyType
 */
const VALID_CURRENCY_CODE = Object.keys(UtilsTypes.CurrencyType);
export function getValidCurrencyType(currencyType: UtilsTypes.CurrencyType | undefined) {
  if (currencyType && VALID_CURRENCY_CODE.includes(currencyType)) {
    return currencyType;
  }
  return UtilsTypes.CurrencyType.HKD;
}
export function getCurrencyCodeByType(currencyType: UtilsTypes.CurrencyType | undefined) {
  return UtilsTypes.CurrencyCode[getValidCurrencyType(currencyType)];
}

/**
 *  将旁白内容中的HK$xx替换为相应的多语言文案
 * @param str 旁白文案 如： HK$5.00 转换为 5.00港元
 * @param filterHTML 是否需要过滤旁白内的HTML标签
 * @returns 转换后的文案描述信息,
 */
export function parseHK$Aria(str: string, filterHTML = false) {
  if (!str) return '';
  const content = filterHTML ? str.replace(/<[^>]+>/g, '') : str;
  const pn = /(HK\$)(\d+(\.d*)*)*/gi;
  return content.replace(pn, (val) => {
    const amountVal = (val || '').replace(/(HK\$)/, '');
    return `${amountVal}${i18n('HK$ aria')}`;
  });
}
/**
 * 拓展parseHK$Aria，支持传入币种currency
 * @param str 旁白文案 如： HK$5.00 转换为 5.00港元
 * @param filterHTML 是否需要过滤旁白内的HTML标签
 * @param currencyType 币种类型，默认为港币
 * @returns 转换后的文案描述信息,
 */
export function parseCurrencyAria(str: string, filterHTML = false, currencyType = UtilsTypes.CurrencyType.HKD) {
  if (!str) return '';
  const content = filterHTML ? str.replace(/<[^>]+>/g, '') : str;

  const currencyCode = getCurrencyCodeByType(currencyType); // 币种码
  const escapedCurrency = currencyCode.replace(/\$/, '\\$');
  const pn = new RegExp(`(${escapedCurrency})(\\d+(\\.\\d*)*)*`, 'gi');

  return content.replace(pn, (val) => {
    const amountVal = (val || '').replace(currencyCode, '');
    return `${amountVal}${i18n(`${currencyCode} aria`)}`;
  });
}

// 定义一个函数来判断数字有多少位小数
export function countDecimalPlaces(number) {
  // 将数字转换为字符串
  const numberString = number.toString();

  // 判断是否包含小数点
  if (numberString.indexOf('.') !== -1) {
    // 获取小数部分
    const decimalPart = numberString.split('.')[1];

    // 返回小数部分的长度
    return decimalPart.length;
  }
  // 如果没有小数部分，则返回 0
  return 0;
}

export function accMul(arg1, arg2) {
  let m = 0;
  const s1 = arg1.toString();
  const s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) { }
  try {
    m += s2.split('.')[1].length;
  } catch (e) { }
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}

/** 获取折扣券的中文折扣,参数discount是万分位！！！ */
export function getDiscountCouponCnRate(discount: number): string {
  const realDiscount = String(divide(minus(10000 - Number(discount)), 100));
  const decimal = realDiscount.slice(0, 1) || '0';
  const digital = realDiscount.slice(1).replace('.', '') || '0';
  if (digital === '0') {
    return decimal;
  }
  return `${decimal}.${digital}`;
}
/** 处理折扣券 */
export function formatDiscount(discount: number, lang: 'zh-hk'|'zh-cn' |'en' = 'zh-hk'): string {
  // 没有传入折扣比例退出
  if (!discount) {
    return '';
  }
  // 当折扣<100时 变成千分位。后端记录的是万分位
  if (discount < 100) {
    return `${divide(discount, 10)}`;
  }
  // 先转成百分位然后算中文是几折
  const cnDiscount = getDiscountCouponCnRate(discount);
  if (lang === 'en') {
    return String(divide(discount, 100));
  }
  return cnDiscount;
};


export function formatDiscountWithUnit(discount: number, lang: 'zh-hk' | 'zh-cn' | 'en' = 'zh-hk') {
  const discountText = formatDiscount(discount, lang);
  if (discount < 100) {
    return i18n('优惠') + discountText + i18n('‰');
  }
  return discountText + i18n('折');
}
